var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#000",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.998 8.706l-2.79 2.792-.708-.707 2.791-2.792-2.79-2.79.707-.707 2.79 2.79L10.791 4.5l.707.707L8.706 8l2.793 2.794-.707.707-2.794-2.794z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuOTk4NDggOC43MDY0Mkw1LjIwNzExIDExLjQ5NzhMNC41IDEwLjc5MDdMNy4yOTEzNyA3Ljk5OTMxTDQuNTAxMTIgNS4yMDkwNkw1LjIwODIzIDQuNTAxOTVMNy45OTg0OCA3LjI5MjJMMTAuNzkwNyA0LjVMMTEuNDk3OCA1LjIwNzExTDguNzA1NTggNy45OTkzMUwxMS40OTg5IDEwLjc5MjZMMTAuNzkxOCAxMS40OTk3TDcuOTk4NDggOC43MDY0MloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgCloseCircleHover as ReactComponent };